var DialogEditCriteriasGroupModule = /** @class */ (function () {
    function DialogEditCriteriasGroupModule() {
    }
    return DialogEditCriteriasGroupModule;
}());
export { DialogEditCriteriasGroupModule };
